/**
 *   This utility function validates that the `groups` property of a
 * `RegExpExecArray` contains the expected group names.
 */
export default function validateGroups<K extends string, V>(
  groups: Record<string, V> | undefined,
  names: readonly K[]
): Record<K, V> {
  if (typeof groups === 'undefined') {
    throw new Error('Expected groups to exist.');
  }

  for (const name of names) {
    if (!(name in groups)) {
      throw new Error(`Expected group "${name}" to exist.`);
    }
  }

  return groups as Record<K, V>;
}
